<template>
  <div class="modal-wrapper">
    <div :class="size" class="modal-dialog" role="document">
      <div class="modal-content modal-content--scrollable">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            <slot name="title"></slot>
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @media (min-width: 768px) {
    .modal-xl {
      width: 90%;
      max-width: 1366px;
    }
  }
</style>

<script>
export default {
  props: {
    size: {
      type: String,
      default: null,
      validator: value => ['modal-xl', 'modal-lg', null].includes(value),
    },
  },
  mounted() {
    $('body').addClass('modal-open');
  },
  destroyed() {
    $('body').removeClass('modal-open');
  },
};
</script>
